import { defineComponent as _defineComponent } from 'vue'
import { ref as _ref } from 'vue';

import __MACROS_useVModel from "/vue-macros/define-models/use-vmodel";
import { watch } from 'vue';
import { AlertingHookService, AlertingHookDto, AlertingHookParams } from '@/api';
import SIcon from '@/components/SIcon.vue';
import SEllipsisTooltip from '@/components/SEllipsisTooltip/SEllipsisTooltip.vue';
import ProviderIcons from '@/utils/provider-icons';

type WebhookWithIcon = AlertingHookDto & { icon: string };

interface Emit {
  (event: 'input', value: AlertingHookDto[]): void
}

export default /*#__PURE__*/_defineComponent({
  __name: 'WebhookTagSelector',
  props: {
  value: null
},
  emits: ["input"],
  setup(__props, { emit }) {



const { value: selectedWebhooks } = __MACROS_useVModel(["value", undefined, "input"]);

let loading = _ref(false);
let alertingHooks = _ref<WebhookWithIcon[]>([]);
const searchString = _ref('');

const getWebhookIcon = (webhook: AlertingHookDto): string => {
  const webhookType = webhook?.params?.type;
  switch (webhookType) {
    case AlertingHookParams.type.GOOGLE_CHAT:
      return ProviderIcons.GOOGLE_CHAT;
    case AlertingHookParams.type.DEFAULT:
    default:
      return ProviderIcons.WEBHOOKS_DARK;
  }
};

const getWebhookType = (webhook: AlertingHookDto): string => {
  const webhookType = webhook?.params?.type;
  switch (webhookType) {
    case AlertingHookParams.type.GOOGLE_CHAT:
      return 'Google Chat';
    case AlertingHookParams.type.DEFAULT:
    default:
      return 'Default';
  }
};

const clear = () => {
  selectedWebhooks.value = [];
  emit('input', selectedWebhooks.value);
};

const fetchWebhookTags = async () => {
  loading.value = true;
  const { data } = await AlertingHookService.getAllAlertingHooks({ type: AlertingHookDto.type.WEBHOOK, itemsPerPage: -1, scope: AlertingHookParams.scope.LINKED_EVENTS });
  // Add icons to webhooks based on their params.type
  alertingHooks.value = (data || []).map((webhook: AlertingHookDto): WebhookWithIcon => ({
    ...webhook,
    icon: getWebhookIcon(webhook),
  }));
  loading.value = false;
};

watch(() => searchString.value, () => {
  fetchWebhookTags();
});

return { __sfc: true,emit, selectedWebhooks, loading, alertingHooks, searchString, getWebhookIcon, getWebhookType, clear, fetchWebhookTags, _ref, __MACROS_useVModel, watch, AlertingHookService, AlertingHookDto, AlertingHookParams, SIcon, SEllipsisTooltip, ProviderIcons }
}

})